export default "__VITE_ASSET__NtEsZKl2__"